<template>
  <el-row id="app">
     <el-col :span="12">
        <el-row>
          <el-col :span="24"><transport-out /></el-col>
        </el-row>
      </el-col>
       <el-col :span="12">
         <el-row>
          <el-col :span="24"><transport-in /></el-col>
        </el-row>
       </el-col>
    </el-row>
</template>

<script>

import TransportIn from '@/components/TransportIn'
import TransportOut from '@/components/TransportOut'

export default {
  name: 'App',
  components: { 
    TransportIn, TransportOut
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ByTransport.vue